import React, { useEffect } from 'react'
import { useListQuery } from 'components/graphql'
import get from 'lodash/get'

const withRemoteData = Component => ({ remoteSort, remoteOptions: { filter, search, query, refreshData, onDataRefreshed, activeFilter, ...restRemote }, ...rest }) => {
	const filterVariables = {
		...filter,
		...rest.filterValues
	}
	let updateRestRemote = { ...restRemote }

	if(activeFilter) {
		updateRestRemote = { ...restRemote, startFromId: null, clearStartFromId: true }
	}

	const searchString = rest.searchString || search || ''
	const searchObj = {
		string: searchString,
		columns: rest.columns.reduce((acc, { accessor, searchable = true }) => {
			if(searchable) {
				acc.push(accessor)
			}
			return acc
		}, [])
	}
	const queryResult = useListQuery(query, {
		...updateRestRemote,
		sort: remoteSort,
		filter: filterVariables,
		search: searchObj
	})

	useEffect(() => {
		const { refetch, loading } = queryResult
		if(refreshData && !loading && typeof refetch === 'function') {
			refetch().then(res => {
				if(typeof onDataRefreshed === 'function') {
					onDataRefreshed()
				}
				return res
			})
		}
	}, [onDataRefreshed, queryResult, refreshData])

	return <Component {...rest} {...queryResult} pageSize={get(queryResult, 'data.length', 0)} withVirtualBody={true}/>
}

export default withRemoteData
